import { call, put, takeEvery } from "redux-saga/effects";
import { quyDinhSoBuoiTrenTuanApi } from "../../../api/category/quyDinhSoBuoiTrenTuanApi";
import { IQuyDinhSoBuoiTrenTuan } from "../../../model/respone/category/IQuyDinhSoBuoiTrenTuan";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eQuyDinhSoBuoiTrenTuanActionIds,
  IQuyDinhSoBuoiTrenTuanActionTypes,
} from "../../action-types/category/IQuyDinhSoBuoiTrenTuanActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.quyDinhSoBuoiTrenTuan;

export function* quyDinhSoBuoiTrenTuanSaga(): any {
  yield takeEvery(eQuyDinhSoBuoiTrenTuanActionIds.LOAD_START, loadWorker);
  yield takeEvery(eQuyDinhSoBuoiTrenTuanActionIds.SAVE_START, saveWorker);
  yield takeEvery(eQuyDinhSoBuoiTrenTuanActionIds.DELETE_START, deleteWorker);
}
function* loadWorker(): any {
  const res: IBaseRespone = yield call(quyDinhSoBuoiTrenTuanApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
function* saveWorker(action: IQuyDinhSoBuoiTrenTuanActionTypes): any {
  const payload = action.payload as IQuyDinhSoBuoiTrenTuan;
  let res: IBaseRespone;
  if (payload.id_quy_dinh > 0) {
    res = yield call(quyDinhSoBuoiTrenTuanApi.Update, payload);
  } else {
    res = yield call(quyDinhSoBuoiTrenTuanApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}
function* deleteWorker(action: IQuyDinhSoBuoiTrenTuanActionTypes): any {
  const res: IBaseRespone = yield call(
    quyDinhSoBuoiTrenTuanApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
